import { QuickAccess } from '../quick-access';
import { Header } from './Header';
import { NavigationLinks } from './NavigationLinks';
import { UserMenu } from './UserMenu';

export const SideNav = () => (
  <aside
    aria-label="Sidebar"
    className="sticky top-0 h-screen w-[250px] shrink-0 overflow-y-auto bg-white shadow-card print:hidden"
  >
    <div className="flex h-screen flex-col">
      <Header />
      <QuickAccess />
      <NavigationLinks />
      <hr className="mt-auto border-gray-2" />
      <UserMenu />
    </div>
  </aside>
);
